import { z } from 'zod';

export const ReminderKindSchema = z.enum(['overdue', 'due_soon', 'stale_draft']);
export type ReminderKind = z.infer<typeof ReminderKindSchema>;

export const ReminderSeveritySchema = z.enum(['high', 'med', 'low']);
export type ReminderSeverity = z.infer<typeof ReminderSeveritySchema>;

export const ReminderSchema = z.object({
  kind: ReminderKindSchema,
  severity: ReminderSeveritySchema,
  invoiceId: z.string().uuid().nullable(),
  formattedNumber: z.string().nullable(),
  clientName: z.string().nullable(),
  message: z.string(),
  daysOverdue: z.number().nullable(),
});
export type Reminder = z.infer<typeof ReminderSchema>;
